app.controller("claimModalController", [
    "$scope", "accounts", "taxRates", "providerId", "CurrentPatient", "TyroAPI", "TyroClaimableItems", "BillingAPI", "ExceptionAPI", "REFERENCE_TYPE", "$filter", "$timeout", "$mdDialog", "$q", "$modal", "initialAction", "LiveReloadService", "PUSH_EVENTS", "InvoiceLiveUpdateService", "PracticeBillingDefaults", "Session",
    function ($scope, accounts, taxRates, providerId, CurrentPatient, TyroAPI, TyroClaimableItems, BillingAPI, ExceptionAPI, REFERENCE_TYPE, $filter, $timeout, $mdDialog, $q, $modal, initialAction, LiveReloadService, PUSH_EVENTS, InvoiceLiveUpdateService, PracticeBillingDefaults, Session) {
        // The practice's sales account (Practice details), preferred for a patient invoice's items.
        let billingDefaults = PracticeBillingDefaults.fallback();
        PracticeBillingDefaults.load().then((d) => (billingDefaults = d));


        $scope.accounts = accounts;
        $scope.taxRates = taxRates;
        $scope.providerId = providerId;
        $scope.$mdDialog = $mdDialog;

        this.$onInit = function () {
            $scope.CP = CurrentPatient;
            $scope.TyroAPI = TyroAPI;
            $scope.BillingAPI = BillingAPI;
            $scope.REFERENCE_TYPE = REFERENCE_TYPE;
            $scope.isProcessing = false;

            $scope.viewState = initialAction || 'LIST';
            $scope.slideDirection = "forward";

            $scope.claims = [];
            $scope.outstanding = null;
            $scope.isLoadingClaims = false;
            $scope.activeInvoice = null;
            $scope.activeClaim = null;

            $scope.pendingItems = [];
            $scope.selectedPendingItems = [];
            $scope.isLoadingPendingItems = false;

            // The codes an uncoded row can be given. Loaded alongside the rows rather than on demand, so the
            // drop-down is ready the moment the administrator opens one.
            $scope.claimableItems = [];
            TyroClaimableItems.load().then(function (items) {
                $scope.claimableItems = items;
            }).catch(function () {
                // The rows still read and claim; only the coder drop-down is lost, and it says so itself.
            });

            $scope.part_payment = { value: 0, account: null, reference_type: null };

            // Which of the PAY view's three states is showing - see payClaim().
            $scope.paymentMode = 'MANUAL';

            fetchPendingItems();

            if ($scope.viewState === 'LIST') {
                fetchClaims();
            }

            subscribeToClaimChanges();
            watchPaymentInvoice();
        };

        // Keeps the list in step with what happens to these claims while it is open: a funder's webhook
        // approving, rejecting or settling one, the processing report sweep, a payment posted at the terminal,
        // another user lodging or paying from their own screen. Without it the list shows whatever was true when
        // it was opened - an unpaid balance that has since been paid, or a claim still pending that was refused.
        //
        // CLAIM_* is published after the claim is saved, so it is what the list reloads on. An invoice event is
        // listened for too, for a change made to one of these invoices outside a claim - a payment recorded
        // against it from the invoice screen. Only for invoices already on the list: the reload reads every
        // claim's invoice from Xero, which is rate limited and shared across the practice.
        //
        // Reloaded rather than patched, because the list endpoint is the one thing that attaches each invoice to
        // its claim. Coalesced over a second, since one webhook can publish an invoice event or several and then
        // its claim event, and those would otherwise be a reload each.
        function subscribeToClaimChanges() {
            const claimEvents = [PUSH_EVENTS.CLAIM_ADDED, PUSH_EVENTS.CLAIM_UPDATED, PUSH_EVENTS.CLAIM_DELETED];
            const invoiceEvents = [PUSH_EVENTS.INVOICE_ADDED, PUSH_EVENTS.INVOICE_UPDATED,
                PUSH_EVENTS.INVOICE_DELETED, PUSH_EVENTS.INVOICE_PAID];

            LiveReloadService.subscribe($scope, {
                events: claimEvents.concat(invoiceEvents),
                coalesceMs: 1000,
                isRelevant: function (payload, pushEvent) {
                    if (claimEvents.indexOf("pushEvent:" + pushEvent.type) !== -1) {
                        return !!$scope.CP.patient && LiveReloadService.sameId(payload.patientId, $scope.CP.patient.id);
                    }
                    return !!payload.invoiceId && ($scope.claims || []).some(claim =>
                        LiveReloadService.sameId(claimInvoiceId(claim), payload.invoiceId));
                },
                reload: function () {
                    // Only onto the list itself. Every other view here is part way through something - a
                    // payment, a claim, an invoice - and each goes back through back(), which reloads anyway.
                    // Nor while the list is busy with an action of its own, which reloads when it finishes.
                    if ($scope.viewState !== 'LIST' || $scope.isProcessing) {
                        return;
                    }
                    fetchClaims({ background: true });
                    fetchPendingItems({ background: true });
                },
            });
        }

        // The reload above skips the PAY view, whose activeInvoice is a copy taken when it opened. That copy is
        // what the form validates against, so an invoice settled elsewhere meanwhile - a terminal payment's
        // webhook, the funder, another user - would still look payable and the server would refuse the payment.
        function watchPaymentInvoice() {
            InvoiceLiveUpdateService.watchInvoice($scope, {
                patientId: function () {
                    return $scope.CP.patient && $scope.CP.patient.id;
                },
                invoice: function () {
                    return $scope.viewState === 'PAY' ? $scope.activeInvoice : null;
                },
                onChanged: function () {
                    $scope.paymentInvoiceChanged = true;
                },
            });
        }

        function claimInvoiceId(claim) {
            return claim && (claim.invoice_id || (claim.invoice && claim.invoice.invoice_id));
        }

        $scope.formatFunder = function (funder) {
            if (!funder) return '-';
            const normalised = funder.toUpperCase();
            if (normalised === 'DVA') return 'DVA';
            if (normalised === 'MEDICARE') return 'Medicare';
            if (normalised === 'PRIVATEHEALTHINSURANCE' || normalised === 'PRIVATE_HEALTH_INSURANCE') return 'Private Health Insurance';
            return funder.charAt(0).toUpperCase() + funder.slice(1).toLowerCase();
        };

        // A claim can be approved overall with individual items refused, so this is per item and says nothing
        // about the claim's own status.
        $scope.isItemUnpaid = function (item) {
            return !!item && (item.status === 'REJECTED' || item.status === 'FAILED');
        };

        // What the invoice itself is owed, which is not the same thing as what the patient owes: between lodgement
        // and settlement it carries the funder's share as well. See getPatientAmountDue() for the patient's part.
        $scope.invoiceAmountOwing = function (claim) {
            if (!claim || !claim.invoice) return 0;

            // A claim between lodgement and settlement carries a draft invoice, and Xero works out what an invoice
            // is owed only once it is approved - which happens when a payment is taken against it or the funder
            // settles it. Until then its total is what is owing, and reading the amount due would say nothing is.
            const invoice = claim.invoice;
            if (invoice.amount_due === undefined || invoice.amount_due === null
                    || (invoice.status === 'DRAFT' && !invoice.amount_due)) {
                return invoice.total || 0;
            }
            return invoice.amount_due;
        };

        // What the patient owes, which is only ever their gap: the invoice less whatever the funder has still to pay
        // into it. It reaches zero the moment that gap is collected, even though the invoice itself still shows the
        // funder's share owing - that share is not the patient's to pay, and showing it as their balance is how a
        // patient gets charged the funder's benefit on top of their gap.
        //
        // Bulk billed means the funder settles the claim in full and the patient owes nothing at all: a bulk-billed
        // Medicare claim, any DVA claim, and an ECLIPSE billing agent (MB) claim, whose Medicare benefit is assigned
        // to the agent and accepted as payment in full. Anything owing on such an invoice is a discrepancy to be
        // sorted out with the funder, never a gap to take off the patient - see
        // TyroProcessingClassType.isBulkBilled() server side, which is what sets the flag on an ECLIPSE claim.
        //
        // An agreement or scheme claim is not bulk billed even where the practice charged no gap: those frameworks
        // permit one, and whether it arises is decided by the charge rather than by the class.
        $scope.getPatientAmountDue = function (claim) {
            if (!claim || !claim.invoice) return 0;
            // CRITICAL: Force the patient balance to $0 if nothing on the claim is payable by the patient
            if (claim.is_bulk_billed) return 0;

            // Nothing collectable while the funder's share is unknown - see funderShareUnknown(). Reported as
            // nothing rather than as the whole invoice, because the one thing that is certain is that the patient
            // does not owe the funder's part of it.
            if ($scope.funderShareUnknown(claim)) return 0;

            const due = roundToCents($scope.invoiceAmountOwing(claim) - $scope.funderBenefitToCome(claim));
            return due > 0 ? due : 0;
        };

        $scope.canTakePayment = function (claim) {
            if (!claim || !claim.invoice) return false;
            if (claim.invoice.status === 'PAID') return false;
            
            // Disable manual payments entirely where the funder settles the claim in full
            if (claim.is_bulk_billed) return false; 
            
            // What the patient owes cannot be worked out yet, so it cannot be asked for - see funderShareUnknown().
            if ($scope.funderShareUnknown(claim)) return false;

            // Nothing left for the patient to pay, which is where a claim lands the moment its gap is collected -
            // what stays owing on the invoice from there is the funder's share, and no payment against it can come
            // from the patient.
            if ($scope.getPatientAmountDue(claim) <= 0) return false;

            // A claim the funder refused, or one that was cancelled, is owed by nobody - its invoice is voided
            // along with it. Anything else that has got as far as having an invoice can be paid, including a claim
            // only just lodged, which is the point of raising the invoice at lodgement: the gap on a patient or
            // scheme claim is known from the eligibility check and is normally collected at the time of service,
            // not days later when the funder finally answers.
            return claim.status !== 'REJECTED' && claim.status !== 'FAILED' && claim.status !== 'CANCELLED';
        };

        // Whether this claim's patient balance is one of the two ECLIPSE amounts that are collected on a Tyro
        // terminal rather than recorded by hand:
        //
        //   - a gap, on an agreement (AG) or scheme (SC) claim: the funder settles its benefit to the practice
        //     and the patient owes the difference, quoted by the eligibility check;
        //   - the whole charge, on a patient (PC) claim: the funder rebates the patient, so none of what it
        //     assesses reaches this invoice.
        //
        // Both are collected face to face, at the time of service, off a card the patient has with them - which
        // is what the terminal is for. Everything else keeps the manual form as its default: a Medicare or DVA
        // balance is normally settled by the funder rather than by the patient, and a claim with no invoice or
        // no known patient share has nothing to send to a terminal.
        //
        // A direct patient invoice is the third, and the plainest: no funder is involved at all, so the whole
        // charge is the patient's and it is raised while they are standing at the desk.
        //
        // Not a restriction on what can be paid. The manual form stays reachable on these claims too - a patient
        // paying cash or by bank transfer is recorded, not charged.
        //
        // Never on a patient claim that is awaiting its cheque - see isAwaitingCheque(). The money for that one is
        // already on its way, so a card taken at the desk would leave the practice paid twice when it arrives.
        //
        // And only for a practice with the Tyro terminal feature on. Without it every balance goes straight to the
        // manual form, as a Medicare or DVA one always has.
        $scope.canTakeTerminalPayment = function (claim) {
            return Session.hasTyroTerminal()
                && (isEclipseClaim(claim) || isPatientInvoice(claim)) && $scope.canTakePayment(claim)
                && !$scope.isAwaitingCheque(claim);
        };

        // A patient claim lodged unpaid, whose account is waiting on the cheque Medicare and the fund post to the
        // patient. The lodgement screen says so as the claim goes, but it is on this list that the practice comes
        // back to the claim, so the list has to say it too - otherwise the row reads as an ordinary unpaid balance
        // and invites a second payment.
        //
        // Still payable here, by hand: the patient bringing the cheque in is how the account is settled, and it is
        // recorded against the invoice like any other payment. Overseas claims are a different transaction type
        // and are never this - no part of them goes through Medicare, so nothing about them produces a cheque.
        $scope.isAwaitingCheque = function (claim) {
            return isPatientClaim(claim) && claim.transaction_type === 'ECLIPSE_CLAIM'
                && !claim.account_paid && $scope.canTakePayment(claim);
        };

        // Where the money on each row has got to, as the pill in its Patient Due column. Answered from the patient's
        // side, because that is what the front desk chases:
        //
        //   PAID            - the invoice is settled, whoever settled it;
        //   AWAITING_CHEQUE - an unpaid patient claim, settled by the cheque the patient brings in;
        //   UNPAID          - the patient owes something and nothing has been paid against it;
        //   PART_PAID       - the patient owes something and part of the invoice has been paid;
        //   AWAITING_FUNDER - the patient's part is done (or was never theirs), and the invoice is left for the
        //                     funder to settle.
        //
        // No pill where there is nothing to say: no invoice yet, a claim refused or cancelled (its status says so,
        // and its invoice is voided with it), or a patient share nobody knows yet (the cell says Pending already).
        const PAYMENT_STATES = {
            PAID: {
                label: 'Paid',
                modifier: 'paid',
                title: 'This invoice has been paid in full.'
            },
            AWAITING_CHEQUE: {
                label: 'Awaiting cheque',
                modifier: 'cheque',
                title: 'Lodged unpaid. Medicare and the health fund post a cheque made out to the provider to the '
                    + 'patient, who brings it in to settle this account. Record it here when it arrives rather than '
                    + 'taking a card payment.'
            },
            UNPAID: {
                label: 'Unpaid',
                modifier: 'unpaid',
                title: 'The patient owes this amount and nothing has been paid against it yet.'
            },
            PART_PAID: {
                label: 'Part paid',
                modifier: 'unpaid',
                title: 'Part of this invoice has been paid, and the patient still owes this amount.'
            },
            AWAITING_FUNDER: {
                label: 'Awaiting funder',
                modifier: 'funder',
                title: 'Nothing is owed by the patient. The rest of this invoice is for the funder to pay.'
            },
            OVERPAID: {
                label: 'Overpaid',
                modifier: 'overpaid',
                title: "The funder paid more than the benefit the patient's gap was worked out from, so the patient "
                    + 'paid more than they owed. Refund them the difference, or keep it as credit for their next visit.'
            }
        };

        $scope.paymentState = function (claim) {
            if (!claim || !claim.invoice) return null;
            if (claim.status === 'REJECTED' || claim.status === 'FAILED'
                    || claim.status === 'CANCELLED' || claim.status === 'VOIDED') {
                return null;
            }
            if ($scope.patientOverpaid(claim) > 0) return PAYMENT_STATES.OVERPAID;
            if (claim.invoice.status === 'PAID') return PAYMENT_STATES.PAID;
            if ($scope.isAwaitingCheque(claim)) return PAYMENT_STATES.AWAITING_CHEQUE;
            if ($scope.funderShareUnknown(claim)) return null;
            if ($scope.getPatientAmountDue(claim) > 0) {
                return claim.invoice.amount_paid > 0 ? PAYMENT_STATES.PART_PAID : PAYMENT_STATES.UNPAID;
            }
            return PAYMENT_STATES.AWAITING_FUNDER;
        };

        // The rows the patient still owes on, counted and totalled for the line above the claims table - so an
        // unpaid balance is seen on opening the list rather than found by reading down its last column.
        //
        // Money owed back to the patient is counted too, on its own, for the same reason: a refund nobody sees is
        // one nobody makes.
        function summariseOutstanding(claims) {
            const summary = { count: 0, total: 0, chequeCount: 0, overpaidCount: 0, overpaidTotal: 0 };
            claims.forEach(function (claim) {
                const overpaid = $scope.patientOverpaid(claim);
                if (overpaid > 0) {
                    summary.overpaidCount++;
                    summary.overpaidTotal = roundToCents(summary.overpaidTotal + overpaid);
                }
                const state = $scope.paymentState(claim);
                if (state !== PAYMENT_STATES.UNPAID && state !== PAYMENT_STATES.PART_PAID
                        && state !== PAYMENT_STATES.AWAITING_CHEQUE) {
                    return;
                }
                summary.count++;
                summary.total = roundToCents(summary.total + $scope.getPatientAmountDue(claim));
                if (state === PAYMENT_STATES.AWAITING_CHEQUE) summary.chequeCount++;
            });
            return summary;
        }

        $scope.payTooltip = function (claim) {
            return $scope.isAwaitingCheque(claim)
                ? "Record the patient's cheque when they bring it in"
                : $scope.popoverPay.content;
        };

        // The funder's share still to be paid into the invoice: what it has assessed where it has, else what the
        // eligibility check quoted, until the day it pays and the invoice records it.
        //
        // ECLIPSE claims only, and not the patient claim among them. On the other classes the funders settle to the
        // provider, so their share is part of what the invoice is owed and none of it is the patient's. A patient
        // (PC) claim works the way a non-bulk-billed Medicare or DVA claim does - the patient pays the practice and
        // the funder rebates the patient - so the whole invoice is theirs to pay and nothing is deducted from it.
        // Deducted, the practice would ask the patient for the gap alone and write off the rest of its charge.
        $scope.funderBenefitToCome = function (claim) {
            if (!isEclipseClaim(claim) || isPatientClaim(claim) || claim.status === 'PAID') return 0;
            const actual = claim.amount_claims_actual_benefit;
            const hasActual = actual !== undefined && actual !== null;
            // A completed assessment is final: an assessed benefit - zero included - is the one coming and must
            // not fall back to the quote. None recorded is different: the processing report sums the per-item
            // benefits and writes null when the report carries none, over a figure the approval webhook may
            // already have recorded, so a null here still means the quoted benefit is expected.
            if (claim.status === 'COMPLETED') return hasActual ? actual : (claim.amount_claims_expected_benefit || 0);
            // Before then a zero can be a placeholder from a partial report rather than an answer, so only a
            // positive figure displaces the quote; reading it as final would charge the patient the funder's share.
            if (hasActual && actual > 0) return actual;
            return claim.amount_claims_expected_benefit || 0;
        };

        // Whether the funder has said what it pays, rather than the eligibility check having quoted it. Read the way
        // funderBenefitToCome() reads it: a positive actual benefit, or any at all once the assessment is complete.
        function funderHasAssessed(claim) {
            if (claim.status === 'PAID' || claim.status === 'COMPLETED') return true;
            return claim.amount_claims_actual_benefit > 0;
        }

        // Whether the patient's gap is the quote's rather than the funder's. It is collected at the time of service
        // all the same - that is the point of quoting it - but the funder can pay more than it quoted, and then the
        // patient has paid too much. Said beside the payment so the desk knows the figure can still move.
        //
        // Never on a patient claim: the patient owes the whole charge there, whatever the funder decides.
        $scope.gapIsEstimate = function (claim) {
            if (!isEclipseClaim(claim) || isPatientClaim(claim) || claim.is_bulk_billed) return false;
            if ($scope.funderShareUnknown(claim) || funderHasAssessed(claim)) return false;
            return $scope.getPatientAmountDue(claim) > 0;
        };

        // What the patient paid beyond their share, owed back to them.
        //
        // Once the funder has paid, the server has worked it out and recorded it - the invoice is settled by then, so
        // there is nothing left here to work it out from. Before that, it is the funder's benefit still to come
        // overshooting what is left owing on the invoice: the patient paid a gap off a quote, and the assessment came
        // in higher. Never more than the patient has actually paid in, since it is only ever their money.
        $scope.patientOverpaid = function (claim) {
            if (!claim) return 0;
            if (claim.patient_overpaid_amount > 0) return claim.patient_overpaid_amount;
            if (!isEclipseClaim(claim) || isPatientClaim(claim) || !claim.invoice || claim.status === 'PAID') return 0;
            if (claim.status === 'REJECTED' || claim.status === 'FAILED' || claim.status === 'CANCELLED'
                    || claim.status === 'VOIDED' || $scope.funderShareUnknown(claim)) {
                return 0;
            }
            const paid = Number(claim.invoice.amount_paid) || 0;
            if (paid <= 0) return 0;
            const over = roundToCents($scope.funderBenefitToCome(claim) - $scope.invoiceAmountOwing(claim));
            return over > 0.005 ? Math.min(over, paid) : 0;
        };

        // Whether the overpayment is held as credit on the patient's Xero contact. Only the server records it, when
        // the funder's payment arrives; until then, or where Xero would not take it, it is for the practice to record.
        $scope.overpaymentRecordedInXero = function (claim) {
            return !!claim && !!claim.patient_overpayment_id;
        };

        // Each funder's part of an ECLIPSE claim's actual benefit, added up over its items - or null where neither
        // funder's part is recorded, so the total stands alone rather than over a pair of blanks.
        //
        // The total is Medicare's and the fund's benefits together, which is what an agreement or scheme claim pays
        // the practice: the fund passes Medicare's benefit on in one consolidated payment. Tyro Health Online shows
        // the two separately, so a $450 claim reads there as two $225 assessments. Shown split here as well, so the
        // two screens can be read against each other.
        $scope.benefitBreakdown = function (claim) {
            if (!isEclipseClaim(claim) || !claim.transaction_items) return null;
            return funderBenefits(claim.transaction_items);
        };

        function funderBenefits(items) {
            let medicare = null;
            let healthFund = null;
            items.forEach(function (item) {
                if (item.medicare_benefit_amount !== undefined && item.medicare_benefit_amount !== null) {
                    medicare = (medicare || 0) + item.medicare_benefit_amount;
                }
                if (item.health_fund_benefit_amount !== undefined && item.health_fund_benefit_amount !== null) {
                    healthFund = (healthFund || 0) + item.health_fund_benefit_amount;
                }
            });
            if (medicare === null && healthFund === null) return null;
            return {
                medicare: medicare === null ? null : roundToCents(medicare),
                healthFund: healthFund === null ? null : roundToCents(healthFund)
            };
        }

        function isEclipseClaim(claim) {
            return !!claim && (claim.transaction_type || '').indexOf('ECLIPSE') === 0;
        }

        // The one ECLIPSE class whose benefit is paid to the patient rather than into the practice's invoice, so
        // the patient owes the whole charge on it. Mirrors TyroProcessingClassType.funderPaysThePatient().
        function isPatientClaim(claim) {
            return !!claim && claim.processing_class === 'PC';
        }

        // An invoice the practice raised straight onto the patient, with no funder in it at all - so nothing is
        // lodged, nothing is assessed, and every figure on it is the patient's from the moment it is raised.
        // It is not a claim; it sits on this list because it carries an invoice and a patient balance.
        function isPatientInvoice(claim) {
            return !!claim && claim.transaction_type === 'PATIENT_INVOICE';
        }

        // Whether the funder's share of this claim is not yet known, which is not the same as it being nothing.
        //
        // A claim invoiced at the charge is settled from two sides: the funder pays its benefit and the patient pays
        // the rest. Where that benefit has been quoted - every claim that ran an eligibility check - the patient's
        // part is arithmetic. A Medicare only claim runs no check, and an overseas claim has none to run, so until
        // the funder assesses it nothing here knows what it will pay.
        //
        // It matters because the alternative is to read the unknown as zero, which makes the whole charge look like
        // the patient's: they would be asked for the funder's share on top of their gap, and the invoice would be
        // left with nothing owing for the funder to pay into - which fails its settlement outright.
        $scope.funderShareUnknown = function (claim) {
            if (!isEclipseClaim(claim) || claim.is_bulk_billed) return false;
            // Nothing about a patient claim's funder is unknown in the sense that matters here: whatever it pays
            // goes to the patient, so none of it was ever coming into this invoice and the whole charge is theirs
            // to pay from the moment it is raised. Read as unknown, the claims screen would refuse the payment.
            if (isPatientClaim(claim)) return false;
            // Settled, assessed, refused or cancelled: the funder has finished with the claim either way, so what
            // is left owing is the patient's and there is nothing still to come. A completed assessment counts -
            // whatever benefit it recorded is the final one, and none recorded means none is coming.
            if (claim.status === 'PAID' || claim.status === 'COMPLETED' || claim.status === 'REJECTED'
                    || claim.status === 'FAILED' || claim.status === 'CANCELLED') {
                return false;
            }
            return !claim.amount_claims_actual_benefit && !claim.amount_claims_expected_benefit;
        };

        // Money is held as binary floating point, so subtracting two amounts that are exact cents produces figures
        // like 705.1799999999998. Everything displayed goes through the currency filter and reads correctly, but
        // the payment field is bound to the number itself - so anything that lands in it is rounded to the cent.
        function roundToCents(amount) {
            return Math.round(amount * 100) / 100;
        }

        $scope.closeModal = function () {
            if ($scope.$mdDialog) {
                $scope.$mdDialog.hide();
            }
        };

        $scope.back = function () {
            $scope.slideDirection = "backward";
            $scope.viewState = 'LIST';
            $timeout(function () {
                // Not if another view has been opened in the meantime - its claim, invoice or seeded lines
                // would be wiped from under it.
                if ($scope.viewState !== 'LIST') return;
                $scope.activeInvoice = null;
                $scope.activeClaim = null;
                // Dropped with the view, so coming back to the same quote re-enters the flow rather than being
                // seen as the binding it already had.
                $scope.quoteToFinish = null;
                // An abandoned invoice is not a half-finished one to come back to: leaving is how it is
                // cancelled, and the next one starts from what is ticked on the list.
                $scope.invoiceItems = [];
                $scope.newInvoiceLine = blankInvoiceLine();
            }, 400);
            fetchClaims();
            fetchPendingItems();
        };

        // Returns its promise: taking the payment on a claim just lodged has to wait for the list this loads, as
        // that is where the claim's Xero invoice is attached.
        //
        // A background fetch is a live update - see subscribeToClaimChanges(). It leaves the list on screen while
        // it loads, rather than swapping it for a spinner, and fails quietly: the list is only as stale as it was.
        function fetchClaims(options) {
            const background = !!(options && options.background);
            if (!background) {
                $scope.isProcessing = true;
                $scope.isLoadingClaims = true;
            }

            return $scope.TyroAPI.getPatientClaims($scope.CP.patient.id)
                .then(function (resp) {
                    // The endpoint returns every Tyro transaction the patient has, and a terminal payment is one
                    // of those without being a claim: nothing was lodged with a funder, so it has no funder, no
                    // benefit, no processing class and no processing report - it would read as a blank row with
                    // actions on it that mean nothing, and canTakePayment() would cheerfully offer to take a
                    // payment against the payment.
                    //
                    // Filtered here rather than server side because the endpoint is transactions-by-patient and
                    // this screen is the one place that means claims by it. The money is not lost from view: the
                    // payment is posted onto the claim's invoice, which is where the practice reads it.
                    const list = (resp.data || []).filter(entry => entry.transaction_type !== 'PATIENT_PAYMENT');
                    $scope.claims = angular.copy(list.sort((a, b) => new Date(b.date_created) - new Date(a.date_created)));
                    $scope.outstanding = summariseOutstanding($scope.claims);
                })
                .catch(function (error) {
                    if (!background) showErrorDialog(error);
                })
                .finally(function () {
                    if (!background) {
                        $scope.isProcessing = false;
                        $scope.isLoadingClaims = false;
                    }
                });
        }

        // A failed fetch stays quiet: the pending items are a convenience on top of the claims list, and
        // blocking the whole dialog over them would be out of proportion.
        //
        // A background fetch is a live update: a claim lodged or released elsewhere takes items off this list or
        // puts them back. It keeps what the administrator has ticked and unticked, and is skipped outright while
        // a row is being coded - a reload would drop the half-made choice.
        function fetchPendingItems(options) {
            const background = !!(options && options.background);
            if (background && $scope.pendingItems.some(item => item.$coding)) return;
            const previouslySelected = {};
            if (background) {
                $scope.pendingItems.forEach(function (item) {
                    previouslySelected[item.tyro_claimable_item_id] = !!item.$selected;
                });
            }
            if (!background) $scope.isLoadingPendingItems = true;

            // PENDING only: an item a claim already carries stays on the record but must not reappear here, or
            // the next claim would seed itself with what is already being claimed. It does come back if its
            // claim is rejected, cancelled or abandoned.
            $scope.TyroAPI.getPatientClaimableItems($scope.CP.patient.id, 'PENDING')
                .then(function (resp) {
                    $scope.pendingItems = (resp.data || []).sort((a, b) => new Date(a.date_created) - new Date(b.date_created));
                    // A row with no code cannot go on a claim, so it starts unticked rather than silently
                    // dropping out of one that looks like it carries everything.
                    $scope.pendingItems.forEach(function (item) {
                        const known = previouslySelected.hasOwnProperty(item.tyro_claimable_item_id);
                        item.$selected = known ? previouslySelected[item.tyro_claimable_item_id] && !!item.item_code
                            : !!item.item_code;
                    });
                    refreshPendingSelection();
                })
                .catch(function (error) { console.error("Failed to load pending claimable items:", error && error.status); })
                .finally(function () { if (!background) $scope.isLoadingPendingItems = false; });
        }

        // Rebuilt in place so the widget's binding sees the same array identity throughout. Only coded rows
        // are ever handed over: an item with no MBS code is not something a funder can be asked to pay.
        function refreshPendingSelection() {
            $scope.selectedPendingItems.length = 0;
            $scope.pendingItems.filter(item => item.$selected && item.item_code)
                .forEach(item => $scope.selectedPendingItems.push(item));
        }

        // --- Coding what a clinician left as a comment ---

        // A clinician records "initial consult" without picking what it bills as. Coding it here is the
        // administrator's judgement, made against the comment, and it turns the row into an ordinary
        // claimable one.
        $scope.needsCoding = function (item) {
            return !!item && !item.item_code;
        };

        $scope.isCoding = function (item) {
            return !!item && item.$coding;
        };

        $scope.startCoding = function (item) {
            item.$coding = true;
            item.$codeChoice = null;
        };

        $scope.cancelCoding = function (item) {
            item.$coding = false;
            item.$codeChoice = null;
        };

        $scope.searchClaimableItems = function (search) {
            return TyroClaimableItems.search($scope.claimableItems, search);
        };

        $scope.claimableItemLabel = function (item) {
            return TyroClaimableItems.label(item);
        };

        // The patient already carries this code on another row, so claiming both would send the funder the
        // same item twice. Said rather than blocked - a genuine second occasion of the same item is legitimate.
        $scope.duplicatesAnotherPendingItem = function (item) {
            const code = item && item.$codeChoice && item.$codeChoice.item_code;
            if (!code) return false;
            return $scope.pendingItems.some(other =>
                other.tyro_claimable_item_id !== item.tyro_claimable_item_id && other.item_code === code);
        };

        // Saved against the record itself, not just held on the screen: the claim is built from what the
        // server holds, and the code has to survive the modal being closed and reopened.
        $scope.applyCode = function (item) {
            if (!item.$codeChoice || $scope.isProcessing) {
                return;
            }

            $scope.isProcessing = true;

            $scope.TyroAPI.updatePatientClaimableItem(
                item.tyro_claimable_item_id, $scope.CP.patient.id, item.$codeChoice.tyro_claimable_item_id)
                .then(function (resp) {
                    const coded = resp.data || {};
                    item.item_code = coded.item_code;
                    item.name = coded.name;
                    item.funder = coded.funder;
                    item.fee = coded.fee;
                    item.$coding = false;
                    item.$codeChoice = null;
                    // Newly claimable, so it joins the claim being built the way a coded row would have.
                    item.$selected = true;
                    refreshPendingSelection();
                })
                .catch(showErrorDialog)
                .finally(function () { $scope.isProcessing = false; });
        };

        // Unticking leaves the item recorded and waiting; it just does not go onto the claim being created
        // now, which is how an admin claims part of what a clinician recorded.
        $scope.togglePendingItem = function () {
            refreshPendingSelection();
        };

        // Counted against the rows that could be ticked, so an uncoded row does not leave the header
        // checkbox permanently unchecked with nothing the administrator can do about it.
        $scope.codedPendingItems = function () {
            return $scope.pendingItems.filter(item => item.item_code);
        };

        $scope.areAllPendingItemsSelected = function () {
            const coded = $scope.codedPendingItems();
            return coded.length > 0 && $scope.selectedPendingItems.length === coded.length;
        };

        $scope.toggleAllPendingItems = function () {
            const select = !$scope.areAllPendingItemsSelected();
            $scope.codedPendingItems().forEach(function (item) { item.$selected = select; });
            refreshPendingSelection();
        };

        // Only the practice's own items carry a fee, so this is what the practice expects to bill, not what any
        // funder will pay. Totals what is ticked, which is what the next claim will carry.
        $scope.pendingItemsTotal = function () {
            return $scope.selectedPendingItems.reduce((total, item) => total + (item.fee || 0), 0);
        };

        // Discards something the admin is not going to claim. Only clears the record the clinician made -
        // nothing has been lodged with a funder at this point.
        $scope.removePendingItem = function (item) {
            $scope.isProcessing = true;

            $scope.TyroAPI.removePatientClaimableItem(item.tyro_claimable_item_id, $scope.CP.patient.id)
                .then(function () {
                    $scope.pendingItems = $scope.pendingItems.filter(
                        pending => pending.tyro_claimable_item_id !== item.tyro_claimable_item_id);
                    refreshPendingSelection();
                })
                .catch(showErrorDialog)
                .finally(function () { $scope.isProcessing = false; });
        };

        // --- Billing the patient directly ---
        //
        // Not everything a practice does is claimable. Private work, a cosmetic procedure, a fee a clinician
        // recorded that no funder is going to pay: until this there was nowhere in the Australian screen to
        // bill any of it, because every invoice here was raised as a side effect of lodging a claim.
        //
        // The items come from the same claimable-item list a claim is built from, so what the practice bills
        // privately reads in Xero exactly as what it claims does - same codes, same names, same prices.

        $scope.invoiceItems = [];
        // An object rather than two properties on the scope: ui-select builds a child scope of its own, so a
        // model bound to a bare name is written there and never reaches this controller - the selection would
        // look made on screen while everything reading it here still saw nothing.
        $scope.newInvoiceLine = blankInvoiceLine();

        function blankInvoiceLine() {
            return { item: null, price: null, quantity: 1 };
        }

        $scope.goToCreateInvoice = function () {
            $scope.slideDirection = "forward";
            $scope.newInvoiceLine = blankInvoiceLine();
            // Seeded from what is ticked above, the way creating a claim is: an admin who has already chosen
            // which recorded items to bill should not have to choose them a second time.
            $scope.invoiceItems = $scope.selectedPendingItems.map(function (pendingItem) {
                return {
                    item_code: pendingItem.item_code,
                    name: pendingItem.name,
                    charge_amount: feeOrNull(pendingItem),
                    quantity: 1,
                    // An item a clinician recorded is work they did, which is health care and so GST-free. The
                    // taxable things are billed by hand: cosmetic work, reports, retail goods.
                    gst_applicable: false,
                    // The record this line bills, so raising the invoice takes it off the pending list.
                    tyro_claimable_item_id: pendingItem.tyro_claimable_item_id,
                };
            });
            $timeout(function () {
                $scope.viewState = 'CREATE_INVOICE';
            }, 100);
        };

        // The practice's own item carries its fee, so choosing one prices the line; a CatTrax reference item
        // carries none and leaves the field empty to be keyed in. Either way the price stays editable before
        // the line is added - what a practice charges privately is its own decision, and the fee held against
        // the item is where that decision usually starts rather than where it ends.
        $scope.onInvoiceItemSelected = function () {
            $scope.newInvoiceLine.price = feeOrNull($scope.newInvoiceLine.item);
        };

        $scope.canAddInvoiceItem = function () {
            return !!$scope.newInvoiceLine.item
                && $scope.newInvoiceLine.price > 0
                && $scope.newInvoiceLine.quantity > 0;
        };

        $scope.addInvoiceItem = function () {
            if (!$scope.canAddInvoiceItem()) return;

            const choice = $scope.newInvoiceLine.item;
            $scope.invoiceItems.push({
                item_code: choice.item_code,
                name: choice.name,
                charge_amount: $scope.newInvoiceLine.price,
                quantity: $scope.newInvoiceLine.quantity,
                // Off by default and ticked on the line below, where it stays visible next to the charge - a
                // GST decision made once in this row and then scrolled away is one nobody re-reads.
                gst_applicable: false,
                // Chosen off the reference list rather than from something a clinician recorded, so there is
                // no record against the patient for this line to consume.
                tyro_claimable_item_id: null,
            });
            $scope.newInvoiceLine = blankInvoiceLine();
        };

        $scope.removeInvoiceItem = function (index) {
            $scope.invoiceItems.splice(index, 1);
        };

        // What one line is worth before GST: the charge is per unit, so two of something costs twice.
        $scope.invoiceLineTotal = function (item) {
            return (item.charge_amount || 0) * (item.quantity || 0);
        };

        // Only a practice item carries a fee; a SYSTEM item is reference data and leaves the charge to be
        // keyed in, which is why an unpriced line is left empty rather than shown as costing nothing.
        function feeOrNull(item) {
            return (item && item.fee !== undefined && item.fee !== null) ? item.fee : null;
        }

        // --- What the invoice comes to ---
        //
        // Shown in full - subtotal, GST, total - rather than as one figure, because the failure this screen has
        // to prevent is nobody thinking about GST at all. A cosmetic invoice going out GST-free is not refused
        // by anything and looks right to everyone who sees it; the practice finds out at BAS time, having never
        // charged the patient the tax it now owes. "GST $0.00" under a four-figure total is what makes that
        // visible while there is still time to tick the box.
        //
        // Xero has the last word on all three - it is the one raising the invoice - and the claims list reads
        // its figures back. These are worked out the same way so they agree.

        // The organisation's own GST rate, matched the way the server matches it when it raises the invoice.
        // Ten per cent where the rates cannot be read, which is the Australian rate and the only one these
        // figures are ever asked for.
        function gstRate() {
            const rate = ($scope.taxRates || []).find(taxRate =>
                (taxRate.tax_type || '').toUpperCase() === 'OUTPUT'
                || (taxRate.tax_name || '').toLowerCase() === 'gst on income');
            const parsed = rate ? parseFloat(rate.tax_display_rate) : NaN;
            return isNaN(parsed) ? 10 : parsed;
        }

        function invoiceLinesTotal() {
            return $scope.invoiceItems.reduce((total, item) => total + $scope.invoiceLineTotal(item), 0);
        }

        // Australian charges are entered GST-inclusive, always: consumer law requires a price quoted to a
        // patient to be a single figure including GST, so the tax is taken back out of what was keyed in
        // rather than added on top of it. Pinned server side too - see BaseBillingServiceImpl's
        // invoiceLineAmountType() - so what Xero raises and what is shown here cannot drift apart.
        $scope.invoiceGst = function () {
            const rate = gstRate();
            const taxable = $scope.invoiceItems
                .filter(item => item.gst_applicable)
                .reduce((total, item) => total + $scope.invoiceLineTotal(item), 0);

            return roundToCents(taxable * rate / (100 + rate));
        };

        $scope.invoiceSubtotal = function () {
            return roundToCents(invoiceLinesTotal() - $scope.invoiceGst());
        };

        $scope.invoiceTotal = function () {
            return roundToCents(invoiceLinesTotal());
        };

        // Every line has to be worth something: Xero takes a zero line, but an invoice carrying one bills the
        // patient nothing for work the practice did and reads as a mistake nobody notices until it is paid.
        $scope.isInvoiceValid = function () {
            return $scope.invoiceItems.length > 0
                && $scope.invoiceItems.every(item =>
                    !!item.item_code && item.charge_amount > 0 && item.quantity > 0);
        };

        // The two Xero accounts the invoice needs: one to post the lines against, and one for the payment to
        // land in. Picked the same way the claim flow and the terminal pick them.
        function accountIdByClass(isBank) {
            const accounts = $scope.accounts || [];
            // Items go to the practice's sales account when the organisation has it.
            const preferred = !isBank && accounts.find(candidate => candidate.account_code === billingDefaults.salesAccountCode);
            const account = preferred || accounts.find(candidate =>
                isBank ? candidate.account_class === 'BANK' : candidate.account_class !== 'BANK');
            return account ? account.account_id : null;
        }

        $scope.createPatientInvoice = function () {
            if (!$scope.isInvoiceValid() || $scope.isProcessing) return;

            const paymentAccountId = accountIdByClass(true);
            const itemsAccountId = accountIdByClass(false);
            if (!paymentAccountId || !itemsAccountId) {
                return showErrorDialog(null, "A bank account and a revenue account are needed before an invoice "
                    + "can be raised. Check the practice's accounting connection in settings.");
            }

            $scope.isProcessing = true;

            $scope.TyroAPI.createPatientInvoice($scope.CP.patient.id, {
                account_payment_id: paymentAccountId,
                account_items_id: itemsAccountId,
                claimable_item_ids: $scope.invoiceItems
                    .map(item => item.tyro_claimable_item_id).filter(Boolean),
                items: $scope.invoiceItems.map(item => ({
                    item_code: item.item_code,
                    name: item.name,
                    charge_amount: roundToCents(item.charge_amount),
                    quantity: item.quantity,
                    gst_applicable: !!item.gst_applicable,
                })),
            }).then(function (resp) {
                $scope.invoiceItems = [];
                // Straight on to collecting it. The whole charge is the patient's - no funder is going to pay
                // any of it - and they are standing at the desk, which is the moment it is collectable.
                goToPaymentForTransaction(resp.data && resp.data.transaction_id);
            }).catch(function (error) {
                $scope.isProcessing = false;
                showErrorDialog(error, "The invoice could not be raised.");
            });
        };

        $scope.viewInvoice = function (claim) {
            if (!claim || !claim.invoice) return;

            $scope.viewState = 'VIEW_ONLY';
            $timeout(function () {
                $scope.activeInvoice = angular.copy(claim.invoice);
                $scope.activeClaim = angular.copy(claim);
            }, 100);
        };

        $scope.payClaim = function (claim) {
            if (!claim || !claim.invoice) return;

            $scope.viewState = 'PAY';
            $scope.paymentInvoiceChanged = false;
            // A gap or patient-claim balance opens on the choice of how to take it, with the terminal put
            // forward and the manual form behind it. Opening straight onto the terminal would raise a payment
            // transaction and throw up Tyro's window before anybody asked for either.
            //
            // Anything else opens on the manual form, exactly as it always has: no terminal is offered on a
            // claim whose balance is the funder's to settle. See canTakeTerminalPayment().
            $scope.paymentMode = $scope.canTakeTerminalPayment(claim) ? 'CHOICE' : 'MANUAL';
            $timeout(function () {
                $scope.part_payment = {
                    // The whole of what the patient owes, which is the gap and nothing else - and which is also the
                    // ceiling the field enforces, so the funder's share can never be taken off them.
                    value: $scope.getPatientAmountDue(claim),
                    account: ($scope.accounts && $scope.accounts.length > 0) ? $scope.accounts[0].account_id : null,
                    // The one way an unpaid patient claim is settled, so it is filled in rather than left to be
                    // picked - see isAwaitingCheque().
                    reference_type: $scope.isAwaitingCheque(claim) ? 'CHEQUE' : null
                };
                $scope.activeClaim = angular.copy(claim);
                $scope.activeInvoice = angular.copy(claim.invoice);
            }, 100);
        };

        $scope.isPaymentValid = function () {
            if (!$scope.activeInvoice || !$scope.activeClaim || $scope.paymentInvoiceChanged) return false;
            
            const dueAmount = $scope.getPatientAmountDue($scope.activeClaim);
            
            return $scope.part_payment.value > 0 &&
                $scope.part_payment.value <= dueAmount &&
                $scope.part_payment.account &&
                $scope.part_payment.reference_type;
        };

        $scope.updatePaidAmount = function () {
            if (!$scope.isPaymentValid()) return;
            $scope.isProcessing = true;

            const body = {
                amount: $scope.part_payment.value,
                account_id: $scope.part_payment.account,
                reference_type: $scope.part_payment.reference_type,
                date: $filter("date")(new Date(), "yyyy-MM-dd"),
            };

            $scope.BillingAPI.updatePayment($scope.CP.patient.id, $scope.activeInvoice.invoice_id, body)
                .then(() => $scope.back())
                .catch(error => { showErrorDialog(error); $scope.isProcessing = false; });
        };

        // --- Taking the payment: the terminal, or recording one taken another way ---

        // Whether the practice is being offered the choice, which is only worth making where a terminal can take
        // this balance. Everything else goes straight to the form and never sees an option it cannot use.
        $scope.isChoosingPaymentMethod = function () {
            return $scope.paymentMode === 'CHOICE';
        };

        // Records a payment somebody already took - cash at the desk, a bank transfer that arrived last week, a
        // card run on a standalone machine. The fallback rather than the default: where a terminal can take the
        // money, taking it is better than typing in that it was taken.
        $scope.useManualPayment = function () {
            $scope.paymentMode = 'MANUAL';
        };

        // Only where the balance is one a terminal can take - see canTakeTerminalPayment(). Mounting the
        // component is what raises the payment transaction and opens Tyro's window, so this is deliberately an
        // action the practice takes rather than something that happens on arrival.
        $scope.useTerminalPayment = function () {
            if (!$scope.canTakeTerminalPayment($scope.activeClaim) || $scope.paymentInvoiceChanged) return;
            $scope.paymentMode = 'TERMINAL';
        };

        // Back to the choice, which is also how an abandoned terminal payment is retried: the component is
        // behind an ng-if on the mode, so leaving destroys it and returning builds a fresh one with a new
        // transaction. Reusing the abandoned row would charge against a transaction the server has discarded.
        $scope.backToPaymentOptions = function () {
            if (!$scope.canTakeTerminalPayment($scope.activeClaim)) return;
            $scope.paymentMode = 'CHOICE';
        };

        // The SDK has been left, however it was left. The claim is reloaded either way and the screen returns to
        // the list, because a charge the patient approved a moment before the operator closed the window is a
        // payment that was taken - and the invoice is the only place that can be read off.
        //
        // Nothing is posted onto the invoice from here. Tyro's own webhook does that, so a payment lands whether
        // or not this browser was still open when the cardholder approved it.
        $scope.onTerminalPaymentComplete = function (status, payload) {
            $scope.back();
        };

        // --- ECLIPSE quotes: lodge the claim post-op, or discard the quote ---

        // A quote stays promotable while OUTSTANDING. Lodging flips the same row to an ECLIPSE_CLAIM server
        // side, after which the status webhooks own it and it is no longer a quote.
        //
        // A check still with Medicare and the health fund is recorded as PENDING and is deliberately not
        // promotable: lodging it would send a claim whose eligibility was never actually answered, and the
        // row reads identically to an assessed quote once it is in this list.
        $scope.isEclipseQuote = function (claim) {
            return !!claim && claim.transaction_type === 'ECLIPSE_ELIGIBILITY' && claim.status === 'OUTSTANDING';
        };

        $scope.isEclipseQuoteAwaitingAssessment = function (claim) {
            return !!claim && claim.transaction_type === 'ECLIPSE_ELIGIBILITY' && claim.status === 'PENDING';
        };

        // Nothing has been lodged with a funder either way, so both can be thrown away - an un-assessed quote
        // is not a financial record, and leaving it in the list with no action on it would strand it.
        $scope.isUnlodgedEclipseQuote = function (claim) {
            return $scope.isEclipseQuote(claim) || $scope.isEclipseQuoteAwaitingAssessment(claim);
        };

        // --- Processing reports ---

        // The ECLIPSE processing report: what Medicare and the health fund assessed, line by line, with the
        // explanation codes that say why anything was reduced or refused. Every lodged ECLIPSE claim has one -
        // in-patient claims of every processing class as well as overseas ones - and it is published on the
        // funders' own schedule, typically the next business day, rather than arriving by webhook. By then the
        // practice has long since closed the claiming screen, so this is where they come back to for it.
        //
        // An eligibility quote has none: nothing was lodged, so neither funder has processed anything.
        $scope.hasProcessingReport = function (claim) {
            return !!claim
                && (claim.transaction_type === 'ECLIPSE_CLAIM' || claim.transaction_type === 'ECLIPSE_OVERSEAS_CLAIM')
                && !!claim.transaction_tyro_id;
        };

        // Offered on a settled claim as well as an unsettled one, unlike the actions above it. The report is
        // the practice's evidence of what was assessed - the document they file against the claim and quote in
        // a dispute - so it stays reachable after the claim has finished moving.
        $scope.canViewProcessingReport = function (claim) {
            return $scope.hasProcessingReport(claim) && claim.status !== 'CANCELLED';
        };

        // Opens the report in the PDF viewer, with a download beside it - the same viewer the patient file
        // list previews documents in, so a report reads the way every other document in CatTrax does.
        //
        // Opening it is also how the claim is checked: the server reads the report from Tyro to render it, and
        // applies whatever it found on the way through. So the list is reloaded afterwards - opening a report
        // is quite often the moment a claim's benefits and item outcomes first appear.
        //
        // A report the funders have not published yet is the normal state until the next business day, and the
        // server says so in as many words. The viewer closes and that message is shown on its own, because
        // nothing has gone wrong and there is nothing to look at.
        $scope.viewProcessingReport = function (claim) {
            if (!$scope.canViewProcessingReport(claim) || $scope.processingReportModal) return;

            $scope.isProcessing = true;
            $scope.processingReportData = null;
            $scope.processingReportClaim = claim;
            $scope.pdfUrl = null;

            // Opened before the request rather than after it. Reading a report is a call out to Tyro and back,
            // and a button that sits dead for a second is a button that gets pressed again.
            $scope.processingReportModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.processing-report-viewer.tpl.html",
                show: true,
                title: "PROCESSING REPORT",
                backdrop: true,
                keyboard: false
            });

            $scope.TyroAPI.downloadProcessingReport(claim.transaction_id, $scope.CP.patient.id)
                .then(function (resp) {
                    // Nothing published yet, which the server answers with an empty 204 - the state every
                    // claim is in until the funders publish, so it is said as a notice rather than reported as
                    // a failure. Nothing was applied to the claim, so the list is left exactly as it is.
                    if (resp.status === 204 || !resp.data || !resp.data.byteLength) {
                        $timeout(function () {
                            $scope.isProcessing = false;
                            $scope.closeProcessingReport();
                            showInfoDialog("Processing report", "Medicare and the health fund have not published "
                                + "a processing report for this claim yet. They usually arrive the next business "
                                + "day after lodgement.");
                        });
                        return;
                    }

                    $timeout(function () {
                        // Closed while the report was in flight. Checked before the blob is made rather than
                        // after: the hide handler has already run, so a blob created now is one nothing will
                        // ever revoke.
                        if (!$scope.processingReportModal) return;

                        $scope.processingReportData = resp.data;
                        $scope.pdfUrl = URL.createObjectURL(new Blob([resp.data], { type: "application/pdf" }));
                    });
                    fetchClaims();
                })
                .catch(function (error) {
                    $timeout(function () {
                        $scope.isProcessing = false;
                        $scope.closeProcessingReport();
                        showErrorDialog(readServerError(error), "The processing report could not be opened.");
                    });
                });
        };

        // Saves the copy already on screen rather than asking Tyro for the report a second time - a second read
        // would be a second call out and could come back different, which is not what "download what I am
        // looking at" should mean.
        $scope.saveProcessingReport = function () {
            if (!$scope.processingReportData || !$scope.processingReportClaim) return;

            const blob = new Blob([$scope.processingReportData], { type: "application/pdf" });
            const filename = $scope.CP.patient.firstName + "_" + $scope.CP.patient.lastName
                + "_processing_report_" + $scope.processingReportClaim.transaction_id + ".pdf";

            if (typeof window.navigator.msSaveBlob !== "undefined") {
                window.navigator.msSaveBlob(blob, filename);
                return;
            }
            const tempLink = document.createElement("a");
            tempLink.href = window.URL.createObjectURL(blob);
            tempLink.setAttribute("download", filename);
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            // Released a beat later, not straight away: some browsers read the URL after the click returns, and
            // revoking it out from under them cancels the save.
            $timeout(() => window.URL.revokeObjectURL(tempLink.href), 500);
        };

        $scope.closeProcessingReport = function () {
            if ($scope.processingReportModal) $scope.processingReportModal.hide();
        };

        // Every way out of the viewer lands here - the buttons, the backdrop, the escape key - so the blob is
        // released in one place rather than in three. A PDF held open is held in memory until the tab goes.
        $scope.$on('modal.hide', function (event, modalInstance) {
            if (!$scope.processingReportModal || modalInstance !== $scope.processingReportModal) return;

            const openUrl = $scope.pdfUrl;
            $scope.processingReportModal = null;
            $scope.processingReportData = null;
            $scope.processingReportClaim = null;
            $scope.pdfUrl = null;

            if (openUrl) {
                // Released a beat later: the viewer is still torn down at this point and reads the URL as it goes.
                $timeout(() => URL.revokeObjectURL(openUrl), 500);
            }
        });

        // The report is requested as an arraybuffer so the PDF survives the trip, which means a failure
        // arrives as bytes too - and showErrorDialog would find no message on it and fall back to the generic
        // wording. The server's own message is the whole point on this path ("no processing report has been
        // published for this claim yet"), so the body is decoded back into an error the dialog can read.
        // Anything that will not decode is passed through untouched.
        function readServerError(error) {
            if (!error || !error.data || !(error.data instanceof ArrayBuffer)) return error;
            try {
                const decoded = JSON.parse(new TextDecoder("utf-8").decode(new Uint8Array(error.data)));
                decoded.message = plainServerMessage(decoded.message);
                return angular.extend({}, error, { data: decoded });
            } catch (e) {
                return angular.extend({}, error, { data: null });
            }
        }

        // Unwraps the server's message from the envelope its error handler puts round every failure -
        // "Internal error while processing your request: [details: ...]". What reaches here now is a genuine
        // fault, so the banner is fair - but the practice still has to read what actually went wrong, and the
        // envelope buries it. An unpublished report no longer comes through this path at all: it is answered
        // with an empty 204 and shown as a notice, which is what it is.
        function plainServerMessage(message) {
            if (!message) return message;
            const details = /\[details:\s*([\s\S]*?)\]\s*$/.exec(message);
            return details ? details[1].trim() : message;
        }

        // The real post-op path: the quote may have been run weeks ago, and finishing it needs none of the
        // original form back, as the backend stored the submission inputs on the row.
        //
        // Hands the quote to the claiming flow's lodgement step rather than lodging it from here. That step is
        // where the claim is reviewed before it goes, where a patient claim's account has to be settled first,
        // and where a refusal on lodgement is shown - so a confirm dialog on this list was skipping the only
        // screen that could deal with any of it, and on a patient claim it lodged straight into the server's
        // refusal with nowhere to fix it.
        $scope.finishEclipseClaim = function (claim) {
            if (!$scope.isEclipseQuote(claim)) return;
            clearPendingQuoteActions();

            $scope.slideDirection = "forward";
            $scope.viewState = 'ELECTRONIC_CLAIM';
            // A fresh object each time, so returning to the same quote is a change the widget's binding sees.
            $scope.quoteToFinish = angular.copy(claim);
        };

        $scope.discardEclipseQuote = function (claim) {
            if (!$scope.isUnlodgedEclipseQuote(claim)) return;
            clearPendingQuoteActions();
            $scope.quoteToBeDiscarded = claim;
            showConfirmDialog("Discard eligibility quote",
                "Discard this eligibility quote? The claim has not been lodged, so nothing is withdrawn from Medicare or the health fund.");
        };

        function _discardEclipseQuote(claim) {
            $scope.isProcessing = true;
            $scope.TyroAPI.deleteTransaction(claim.transaction_id, $scope.CP.patient.id)
                .then(function () { $timeout(() => fetchClaims()); })
                .catch(function (error) {
                    $timeout(function () {
                        $scope.isProcessing = false;
                        showErrorDialog(error, "The eligibility quote could not be discarded.");
                    });
                });
        }

        // The un-lodged eligibility quote is the only row the trash icon acts on. Cancelling a lodged claim
        // would have to go through Tyro, which has not implemented the cancellation API - it answers 400 - so
        // the icon is shown greyed on a real claim rather than offering an action that cannot work.
        $scope.canRemoveClaim = function (claim) {
            return $scope.isUnlodgedEclipseQuote(claim);
        };

        $scope.removeClaim = function (claim) {
            if ($scope.isUnlodgedEclipseQuote(claim)) return $scope.discardEclipseQuote(claim);
        };

        $scope.removeTooltip = function (claim) {
            if ($scope.isUnlodgedEclipseQuote(claim)) {
                return "Discard this eligibility quote";
            }
            // Nothing was ever lodged on one of these, so Tyro is not what stands in the way: the invoice is,
            // and an invoice the practice has raised on a patient is voided in Xero rather than deleted here.
            if (isPatientInvoice(claim)) {
                return "Void this invoice in Xero to cancel it";
            }
            return "Cancelling a lodged claim is not supported by Tyro yet";
        };

        function clearPendingQuoteActions() {
            $scope.quoteToBeDiscarded = null;
        }

        // A plain notice with an OK on it, using the same dialog the confirmations use with nothing armed
        // behind it. For an outcome that is neither a failure nor a question - a processing report the funders
        // have not published yet, above all, which is where every claim sits until they do.
        function showInfoDialog(title, content) {
            clearPendingQuoteActions();
            showConfirmDialog(title, content);
        }

        function showConfirmDialog(title, content) {
            $scope.negativeButton = null;
            $scope.generalModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.general.tpl.html",
                show: true,
                title: title,
                content: content,
                backdrop: true,
                keyboard: false,
            });
        }

        // OK on the confirm dialog. Dismissing it instead leaves the pending action unarmed.
        $scope.onGeneralClick = function () {
            if ($scope.generalModal) $scope.generalModal.hide();

            if ($scope.quoteToBeDiscarded) {
                _discardEclipseQuote(angular.copy($scope.quoteToBeDiscarded));
            }
            clearPendingQuoteActions();
        };

        // Entry point for every electronic claim - Medicare, DVA and ECLIPSE in-patient. Funder selection,
        // patient verification and the claiming UI all live in the tyroMedipassWidget.
        $scope.goToCreateClaim = function () {
            $scope.slideDirection = "forward";
            // Cleared, or a claim built from scratch after finishing one would open on the previous quote's
            // lodgement step instead of at the start.
            $scope.quoteToFinish = null;
            $timeout(function () {
                $scope.viewState = 'ELECTRONIC_CLAIM';
            }, 100);
        };

        // Returns to the claims list so the new transaction is visible, rather than closing the dialog out
        // from under the user.
        //
        // TAKE_PAYMENT is the practice choosing, on the lodgement screen, to collect the patient's gap there and
        // then: they land on the payment screen for the invoice that lodgement raised instead of on the list, where
        // they would have to find the claim again - and where a gap that nothing chases gets forgotten.
        $scope.onWidgetComplete = function (status, payload) {
            $timeout(function () {
                if (status === 'TAKE_PAYMENT' && payload && payload.transaction_id) {
                    return goToPaymentForTransaction(payload.transaction_id);
                }
                // The claim went, nothing was refused and there is nothing to collect - so the whole dialog
                // closes rather than dropping back to a list the practice only came here to add to. The claim is
                // on that list when they next open it.
                if (status === 'LODGED_COMPLETE') {
                    return $scope.closeModal();
                }
                $scope.back();
            });
        };

        // The row as the claims list returns it, which is the only shape the payment screen can work from: a
        // lodgement or an invoice response carries an invoice id, while the payment is priced off the invoice
        // itself, and this is the endpoint that attaches it. A row that cannot be read, or cannot be paid, is
        // left on the list - the payment can still be taken from there, and a payment screen with no invoice on
        // it would help nobody.
        function goToPaymentForTransaction(transactionId) {
            $scope.slideDirection = "backward";
            $scope.viewState = 'LIST';
            $scope.activeInvoice = null;
            $scope.activeClaim = null;
            fetchPendingItems();

            fetchClaims().then(function () {
                const claim = ($scope.claims || []).find(entry => entry.transaction_id === transactionId);
                if (claim && $scope.canTakePayment(claim)) {
                    $scope.payClaim(claim);
                }
            });
        }

        // The ECLIPSE processing class in the short form the claims table has room for. The long names live
        // server side on the processing report, where there is space to spell them out; here the point is only
        // to tell two ECLIPSE claims apart at a glance.
        //
        // PC is retired and cannot be lodged any more, but rows claimed under it are still on the record and
        // still have to read as what they were.
        const PROCESSING_CLASS_LABELS = {
            AG: 'Agreement',
            SC: 'Scheme',
            MB: 'Billing Agent',
            MO: 'Medicare Only',
            PC: 'Patient Claim'
        };

        // What the fund's processing report says about an overseas claim, in the terms the ECLIPSE documentation
        // uses - the same list the claiming widget shows on a claim it has just lodged. Overseas only: the coarse
        // status reads PENDING from lodgement until the fund answers, and this is what says which of the fund's
        // steps the claim has actually reached in between. An in-patient claim's status is its webhooks' alone.
        const OVERSEAS_REPORT_STATUS_LABELS = {
            SUCCESS: 'Submitted - passed initial checks',
            PENDING: 'Lodged, awaiting the health fund',
            RECEIVED: 'Received by the health fund',
            HEALTH_FUND_VERIFIED: 'Health fund verification complete',
            HEALTH_FUND_ASSESSING: 'Being assessed by the health fund',
            HEALTH_FUND_UNPROCESSED: 'Lodged with the health fund, not yet processed',
            COMPLETE: 'Assessment complete',
            HEALTH_FUND_REJECTED: 'Rejected by the health fund',
            HEALTH_FUND_UNAVAILABLE: 'Health fund unavailable',
            MEDICARE_REJECTED: 'Rejected by Medicare',
            MEDICARE_UNAVAILABLE: 'Medicare unavailable',
            REQUESTED_DELETE: 'Deletion requested',
            REJECTED: 'Refused on submission',
            DECLINED: 'Refused on submission'
        };

        function isOverseasClaim(claim) {
            return !!claim && claim.transaction_type === 'ECLIPSE_OVERSEAS_CLAIM';
        }

        $scope.overseasReportStatusLabel = function (claim) {
            if (!isOverseasClaim(claim) || !claim.overseas_report_status) return null;
            return OVERSEAS_REPORT_STATUS_LABELS[claim.overseas_report_status] || claim.overseas_report_status;
        };

        // An overseas claim the fund has remitted. The remittance is the fund's settlement into the invoice - the
        // healthFundPaidInvoice event, which records the benefit actually paid and posts it in Xero - so the row
        // says so in those words, rather than leaving the practice to infer it from an invoice status.
        $scope.isRemittedOverseasClaim = function (claim) {
            return isOverseasClaim(claim) && claim.status === 'PAID';
        };

        // "Eclipse Claim - Scheme" rather than "Eclipse Claim". The processing class is what decides how an
        // ECLIPSE claim is assessed and what it pays, so two rows reading identically while settling
        // differently is the one thing this column must not do. A Medicare or DVA claim has no processing
        // class, and neither does a claim recorded before one was captured, so both read as they always have.
        $scope.formatClaimType = function (claim) {
            if (!claim) return '';

            const type = formatTransactionType(claim.transaction_type);
            const processingClass = PROCESSING_CLASS_LABELS[claim.processing_class];

            return processingClass ? type + ' - ' + processingClass : type;
        };

        function formatTransactionType(type) {
            if (!type) return '';
            return type.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, letter => letter.toUpperCase());
        }

        $scope.popoverPreview = { content: "View attached invoice" };
        $scope.popoverPay = { content: "Take patient payment for remainder" };
        $scope.popoverProcessingReport = { content: "View the ECLIPSE processing report" };

        // The server's own message is the actionable one on these paths - "an agreement or scheme ECLIPSE claim
        // requires an informed financial consent code", "this eligibility check was rejected: ..." - and it
        // names the field to go and fix. Shown rather than replaced by the generic wording, with `lead` saying
        // which action failed in plain English above it.
        function showErrorDialog(error, lead) {
            // Status and message only. The rejected response carries the request that failed with it, and on
            // these paths that request is a claim - the patient, their card details and what was billed.
            if (error) console.error("Claim request failed:", error.status, ExceptionAPI.serverMessage(error));

            // Read out of the REST layer's wrapper, so the funder's own sentence is what appears rather than
            // "Internal error while processing your request: [details: ...]" around it.
            const detail = ExceptionAPI.serverMessage(error);
            // The template only renders the detail underneath a lead, so a server message arriving without one
            // still gets a lead rather than falling back to the generic "unable to process your request".
            $scope.alertMessage = lead || (detail ? "CatTrax could not complete that action." : null);
            $scope.alertDetail = detail;

            $scope.serverErrorModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                show: true,
                title: "CatTrax has encountered an error",
            });
        }
    }
]);